export default __webpack_public_path__ + "media/images/features/ana/step_image-6a68d65082cbff9f1b4742252331c307.png";